import React from 'react'
import classNames from 'classnames'

import style from './TmoTextarea.module.css'

function TmoTextarea({ value = '', onChange, type, id, className, testId, ...rest }) {
  const handleChange = (e) => {
    onChange(e.target.value)
  }
  return (
    <textarea
      className={classNames(
        type === 'primary' ? style.primary : style.textarea,
        type === 'primary' && value && style.outline_primary,
        className
      )}
      id={id}
      value={value}
      onChange={handleChange}
      data-testid={testId}
      {...rest}
    />
  )
}

export default TmoTextarea
